import * as TYPES from './mutationTypes'

export default {
  updateComputingChainId(state, param) {
    state.chainId = param
  }
}
